import React, { Fragment, useState } from 'react'
import { useStaticQuery, graphql, Link } from "gatsby"
import { Dialog, Disclosure, Transition } from '@headlessui/react'
import { MenuIcon, XIcon, ChevronDownIcon } from '@heroicons/react/outline'
import { StaticImage } from "gatsby-plugin-image"

const MobileDrawerFullNew = ({ isContactPage }) => {
  const [open, setOpen] = useState(false)

  const data = useStaticQuery(graphql`
    query MobileDrawerFullNewQuery {
      prismicGeneralSettings {
        data {
          tab_name_1
          tab_name_2
          tab_name_3
          tab_link_3 {
            link_type
            url
          }
          drop_down_menu_name_1
          drop_down_menu_name_2
          drop_down_menu_name_3
          drop_down_menu_1 {
            menu_name
            menu_link {
              uid
              link_type
              url
            }
          }
          drop_down_menu_2 {
            menu_name
            menu_link {
              uid
              link_type
              url
            }
          }
          drop_down_menu_3 {
            menu_name
            menu_link {
              uid
              link_type
              url
            }
          }
          static_menu
          static_menu_link {
            uid
          }
        }
      }
    }
  `)

  const doc = data.prismicGeneralSettings
  const menuOneList = doc.data.drop_down_menu_1
  const menuTwoList = doc.data.drop_down_menu_2
  const menuThreeList = doc.data.drop_down_menu_3

  return (
    <>
      <div className="w-2/3 xl:hidden flex justify-end">
        {isContactPage
          ?
          null
          :
          <Link to={doc.data.static_menu_link ? `/${doc.data.static_menu_link.uid}` : "/"}>
            <button className="w-full md:w-auto bg-site-red hover:bg-site-red-hover font-display font-semibold text-sm md:text-lg text-white uppercase tracking-wider px-3 py-2">
              Contact Us
            </button>
          </Link>
        }

        <button
          className="text-site-gray focus:outline-none focus:ring-2 focus:ring-white bg-transparent hover:bg-transparent p-0 ml-4"
          onClick={() => setOpen(true)}
        >
          <span className="sr-only">Open panel</span>
          <MenuIcon className="h-6 w-6 text-white" aria-hidden="true" />
        </button>
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" static className="fixed inset-0 overflow-hidden z-50" open={open} onClose={setOpen}>
          <div className="absolute inset-0 overflow-hidden">
            <Transition.Child
              as={Fragment}
              enter="ease-in-out duration-500"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in-out duration-500"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <div className="fixed inset-y-0 right-0 pl-10 max-w-full flex">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <div className="relative w-screen max-w-md">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 left-0 -ml-8 pt-4 pr-2 flex sm:-ml-10 sm:pr-4">
                      <button
                        className="text-white focus:outline-none focus:ring-2 focus:ring-white bg-transparent hover:bg-transparent p-0"
                        onClick={() => setOpen(false)}
                      >
                        <span className="sr-only">Close panel</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="h-full flex flex-col py-6 bg-site-green-light shadow-xl overflow-y-scroll">
                    <nav className="flex flex-col mt-4 px-4">
                      <div className="w-32">
                        <StaticImage
                          src="../../images/logos/SRA-831b-logo-dark.png"
                          width={236}
                          quality={95}
                          formats={["AUTO", "WEBP", "AVIF"]}
                          alt="logo"
                        />
                      </div>

                      <div className="mt-4">
                        <Link to="/">
                          <button className="w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-black  hover:bg-black focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                            {doc.data.tab_name_1 ? doc.data.tab_name_1 : "Home"}
                          </button>
                        </Link>
                      </div>

                      <Disclosure as="div" className="mt-4">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="flex justify-between w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-black  hover:bg-black focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                              <span>{doc.data.drop_down_menu_name_1 ? doc.data.drop_down_menu_name_1 : "Menu Name"}</span>
                              <ChevronDownIcon
                                className={`${
                                  open ? 'transform rotate-180' : ''
                                } w-5 h-5 text-white`}
                              />
                            </Disclosure.Button>
                            <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                              {menuOneList.map((item, index) => {
                                return (
                                  item.menu_link.link_type === "Document" || item.menu_link.link_type === "Any"
                                  ?
                                    <Link
                                      key={index}
                                      to={item.menu_link.uid ? `/${item.menu_link.uid}` : "/"}
                                      className="-m-3 p-3 flex items-start"
                                    >
                                      <div className="ml-4">
                                        <p className="font-display text-red-600 text-base font-bold">{item.menu_name ? item.menu_name : 'Menu Item'}</p>
                                      </div>
                                    </Link>
                                  :
                                  item.menu_link.link_type === "Web" || item.menu_link.link_type === "Media"
                                  ?
                                    <a
                                      href={item.menu_link.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="-m-3 p-3 flex items-start"
                                    >
                                      <div className="ml-4">
                                        <p className="font-display text-red-600 text-base font-bold">{item.menu_name ? item.menu_name : 'Menu Item'}</p>
                                      </div>
                                    </a>
                                  :
                                  null
                                )
                              })}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>

                      <Link to="/testimonials">
                        <button className="flex justify-between w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-black  hover:bg-black focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75 mt-4">
                          Testimonials
                        </button>
                      </Link>

                      <Disclosure as="div" className="mt-4">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="flex justify-between w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-black  hover:bg-black focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                              <span>{doc.data.drop_down_menu_name_2 ? doc.data.drop_down_menu_name_2 : "Menu Name"}</span>
                              <ChevronDownIcon
                                className={`${
                                  open ? 'transform rotate-180' : ''
                                } w-5 h-5 text-white`}
                              />
                            </Disclosure.Button>
                            <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                              {menuTwoList.map((item, index) => {
                                return (
                                  item.menu_link.link_type === "Document" || item.menu_link.link_type === "Any"
                                  ?
                                    <Link
                                      key={index}
                                      to={item.menu_link.uid ? `/${item.menu_link.uid}` : "/"}
                                      className="-m-3 p-3 flex items-start"
                                    >
                                      <div className="ml-4">
                                        <p className="font-display text-red-600 text-base font-bold">{item.menu_name ? item.menu_name : 'Menu Item'}</p>
                                      </div>
                                    </Link>
                                  :
                                  item.menu_link.link_type === "Web" || item.menu_link.link_type === "Media"
                                  ?
                                    <a
                                      href={item.menu_link.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="-m-3 p-3 flex items-start"
                                    >
                                      <div className="ml-4">
                                        <p className="font-display text-red-600 text-base font-bold">{item.menu_name ? item.menu_name : 'Menu Item'}</p>
                                      </div>
                                    </a>
                                  :
                                  null
                                )
                              })}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>

                      <Disclosure as="div" className="mt-4">
                        {({ open }) => (
                          <>
                            <Disclosure.Button className="flex justify-between w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-black  hover:bg-black focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                              <span>{doc.data.drop_down_menu_name_3 ? doc.data.drop_down_menu_name_3 : "Menu Name"}</span>
                              <ChevronDownIcon
                                className={`${
                                  open ? 'transform rotate-180' : ''
                                } w-5 h-5 text-white`}
                              />
                            </Disclosure.Button>
                            <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-500">
                              {menuThreeList.map((item, index) => {
                                return (
                                  item.menu_link.link_type === "Document" || item.menu_link.link_type === "Any"
                                  ?
                                    <Link
                                      key={index}
                                      to={item.menu_link.uid ? `/${item.menu_link.uid}` : "/"}
                                      className="-m-3 p-3 flex items-start"
                                    >
                                      <div className="ml-4">
                                        <p className="font-display text-red-600 text-base font-bold">{item.menu_name ? item.menu_name : 'Menu Item'}</p>
                                      </div>
                                    </Link>
                                  :
                                  item.menu_link.link_type === "Web" || item.menu_link.link_type === "Media"
                                  ?
                                    <a
                                      href={item.menu_link.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="-m-3 p-3 flex items-start"
                                    >
                                      <div className="ml-4">
                                        <p className="font-display text-red-600 text-base font-bold">{item.menu_name ? item.menu_name : 'Menu Item'}</p>
                                      </div>
                                    </a>
                                  :
                                  null
                                )
                              })}
                            </Disclosure.Panel>
                          </>
                        )}
                      </Disclosure>

                      {isContactPage
                        ?
                        null
                        :
                        <div className="mt-4">
                          <Link to={doc.data.static_menu_link ? `/${doc.data.static_menu_link.uid}` : "/"}>
                            <button className="w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-red focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                              Contact Us
                            </button>
                          </Link>
                        </div>
                      }

                      <div className="mt-4">
                        <Link to="/qualify">
                          <button className="w-full px-4 py-2 text-base uppercase font-medium text-left text-white bg-site-red focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                            Apply Now
                          </button>
                        </Link>
                      </div>
                    </nav>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}

export default MobileDrawerFullNew